import { connect } from 'react-redux';

import * as DeveloperActions from 'app/developer-v3/Actions';
import { buildPartialDefinition } from 'app/developer-v3/utils';
import {
  currentAppTitle,
  currentSelectedApi,
  currentTestLogs,
  currentTestRequest,
} from 'app/developer-v3/selectors';

import RequestTester from './RequestTester';

import type { ObjectType, OperationMethodType } from 'app/developer-v3/types';
import type { RequestSchema } from 'app/developer-v3/platformSchema/request';

import type { TestData } from './types';

type OwnProps = {
  appId: number;
  versionNumber: string;
  testType: ObjectType;
  objectKey: string;
};

const mapStateToProps = state => ({
  appName: currentAppTitle(state),
  selectedApi: currentSelectedApi(state),
  testRequest: currentTestRequest(state),
  testLogs: currentTestLogs(state),
});

const mapDispatchToProps = (dispatch, ownProps: OwnProps) => ({
  async clearRequest() {
    dispatch(DeveloperActions.resetTestLogs());
    dispatch(DeveloperActions.resetTestRequest());
  },
  async executeRequest(
    request: RequestSchema,
    authenticationId: string,
    operationMethod: OperationMethodType,
    testData: TestData
  ) {
    const { appId, versionNumber, testType, objectKey } = ownProps;
    dispatch(DeveloperActions.resetTestLogs());
    dispatch(DeveloperActions.resetTestRequest());

    const partialDefinition = buildPartialDefinition(
      testType,
      objectKey,
      operationMethod,
      request
    );

    await dispatch(
      DeveloperActions.executeRequest(
        appId,
        versionNumber,
        testType,
        objectKey,
        partialDefinition,
        authenticationId,
        operationMethod,
        testData
      )
    );

    return dispatch(DeveloperActions.getAllTestLogs(appId, versionNumber));
  },
  getLogs() {
    const { appId, versionNumber } = ownProps;
    dispatch(DeveloperActions.getAllTestLogs(appId, versionNumber));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(RequestTester);
